export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";